import React from 'react';

import BooksOfAccountsModule from './books-of-accounts.module';
import BooksOfAccounts from 'enums/books-of-accounts';

const BooksOfAccountsGeneralEntriesModule = () => {
  return (
    <div>
      <BooksOfAccountsModule type={BooksOfAccounts.GeneralEntriesBook} />
    </div>
  );
};

export default BooksOfAccountsGeneralEntriesModule;
